"use strict";

exports.__esModule = true;
exports.NavbarSettingsMenuController = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = require("styled-components");
var _NavbarSettingsMenuContext = require("./NavbarSettingsMenuContext");
var _SwitchPlant = require("../../LandingScreen/ElevateSettingsMenu/SwitchPlant");
var _AuthContext = require("../../Auth/AuthContext");
var _switchPlant = require("./switchPlant");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var NavbarSettingsMenuController = exports.NavbarSettingsMenuController = function NavbarSettingsMenuController(_ref) {
  var settingsMenu = _ref.settingsMenu,
    appList = _ref.appList,
    showApps = _ref.showApps,
    children = _ref.children;
  var _useState = (0, _react.useState)(false),
    isSwitchPlantOpen = _useState[0],
    setIsSwitchPlantOpen = _useState[1];
  var theme = (0, _react.useContext)(_styledComponents.ThemeContext);
  var _React$useContext = _react["default"].useContext(_AuthContext.AuthContext),
    permissions = _React$useContext.permissions;
  return /*#__PURE__*/_react["default"].createElement(_NavbarSettingsMenuContext.NavbarSettingsMenuContext.Provider, {
    value: {
      settingsMenu: settingsMenu,
      appList: appList,
      showApps: showApps,
      isSwitchPlantOpen: isSwitchPlantOpen,
      setIsSwitchPlantOpen: setIsSwitchPlantOpen
    }
  }, children, (0, _switchPlant.shouldEnableSwitchPlant)(permissions) && /*#__PURE__*/_react["default"].createElement(_SwitchPlant.SwitchPlant, {
    isOpen: isSwitchPlantOpen,
    setIsSwitchPlantOpen: setIsSwitchPlantOpen,
    theme: theme
  }));
};